import { useOutletContext, useLocation } from 'react-router-dom';
import Grid from '../../components/grid/Grid';
import { getDataitemsForDevice } from '../../services/DataitemsAPI';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { formatToBrowserTime } from '../../utils/timeFormat';
import DataitemsHistory from './dataitemsHistory/DataitemsHistory';
import { Dialog } from '@mui/material';
import './Dataitems.css'
import { toast } from 'react-toastify';

const Dataitems = () => {
    const location = useLocation();

    const ctx = useOutletContext?.() || {};
    const qs = new URLSearchParams(location.search);
    const model = ctx?.model ?? qs.get('model') ?? '';
    const serialNumber = ctx?.serialNumber ?? qs.get('serialNumber') ?? '';

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [open, setOpen] = useState(false);
    const [propertyName, setPropertyName] = useState("");

    const buildSearchData = () => {
        return {
            device_name: `${model}-${serialNumber}`,
        };
    };

    const headers = [
        { key: 'id', label: 'ID', visible: false },
        { key: 'PK', label: 'Asset Name', visible: false },
        { key: 'di_name', label: 'Name', width: '30%' },
        { key: 'di_Value', label: 'Value', width: '40%' },
        { key: 'last_Modified', label: 'Last Modified', width: '35%' },
    ];

    const mapApiResponseToGridData = (dataArray) => {
        return (dataArray ?? []).map((item, index) => ({
            id: index + 1,
            PK: item?.PK ?? '',
            di_name: item?.name ?? '',
            di_Value: item?.value ?? '',
            last_Modified: item?.last_modified
                ? formatToBrowserTime(item.last_modified, false, false) // 24-hour with millis
                : '',
        }));
    };

    const loadData = async (searchData) => {
        try {
            setLoading(true);
            const raw = await getDataitemsForDevice(searchData);  // Fetch real data from signed AWS request
            const formatted = Array.isArray(raw) ? raw : [raw]; // Ensure it's an array
            const mapped = mapApiResponseToGridData(formatted);
            setData(mapped);
        } catch (err) {
            console.error('Fetch failed:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!model || !serialNumber) {
            setLoading(false);
            toast.error('Missing model or serial number.');
            return;
        }
        loadData(buildSearchData());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [model, serialNumber]);

    const handleReset = () => {
        loadData(buildSearchData());
    };

    const handleRowClick = (e) => {
        setOpen(true);
        setPropertyName(e.di_name)
    }


    return (
        <div className='di-page-wrapper'>
            <div className="di-header ">
                <button className="btn btn-primary" onClick={handleReset}>
                    <FontAwesomeIcon icon={faSyncAlt} className="me-1" />
                    Refresh
                </button>
            </div>
            <div className='di-content'>
                <Grid
                    headers={headers}
                    data={data}
                    rowsPerPage={50}
                    canMultiSelect={false}
                    onRowClick={handleRowClick}
                    loading={loading}
                    sortable={true}
                />
            </div>
            <Dialog open={open} onClose={() => setOpen(false)} classes={{ paper: "custom-dialog" }} maxWidth="md">
                <DataitemsHistory deviceName={model + '-' + serialNumber} propertyName={propertyName} />
            </Dialog>
        </div>
    );
};

export default Dataitems;